import { useEffect } from 'react';
import { locales } from '@americanexpress/conditional-features';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { getTravelerLocale } from '../utils/travelerDataUtils';
import { getIsTravelerInDualLanguageMarket } from '../utils/getIsTravelerInDualLanguageMarket';
import { useTravelerData } from './useTravelerData';

const fallbackLocales = {
  'es-US': locales.EN_US,
  [locales.ZH_HK]: locales.EN_HK,
};

export const useLocaleBasedRedirect = (router) => {
  const { travelerData } = useTravelerData();
  const locale = useSelector(getActiveLocaleSelector);
  let travelerLocale = getTravelerLocale(travelerData);
  if (travelerLocale in fallbackLocales) {
    travelerLocale = fallbackLocales[travelerLocale];
  }

  const isTravelerInWrongLocale = travelerLocale
  && travelerLocale.toLowerCase() !== locale.toLowerCase();
  const isTravelerInDualLanguageMarket = getIsTravelerInDualLanguageMarket(travelerLocale, locale);

  useEffect(() => {
    if (isTravelerInWrongLocale && !isTravelerInDualLanguageMarket && router) {
      router.push(`/${travelerLocale.toLowerCase()}/travel/`);
    }
  }, [
    locale,
    travelerLocale,
    isTravelerInWrongLocale,
    isTravelerInDualLanguageMarket,
    router,
  ]);

  return isTravelerInWrongLocale && !isTravelerInDualLanguageMarket;
};
